import React from 'react';
import { RestaurantProvider } from 'providers';
import Admin from './Page';

export default function Page() {
  return (
    <RestaurantProvider>
      <Admin />
    </RestaurantProvider>
  );
}
